"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import SpinnerLoader from "@/components/common/SpinnerLoader";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { DropLocation } from "@/components/waves/drops/Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useParams, useRouter } from "next/navigation";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import DropsList from "./DropsList";
const REQUEST_SIZE = 10;
export default function Drops() {
  const $ = _c(48);
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  const params = useParams();
  let t0;
  if ($[0] !== params?.user) {
    t0 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleOrWallet = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const observerRef = useRef(null);
  const bottomRef = useRef(null);
  const t1 = connectedProfile?.handle ?? null;
  let t2;
  if ($[2] !== handleOrWallet || $[3] !== t1) {
    t2 = [QueryKey.PROFILE_DROPS, {
      handleOrWallet,
      context_profile: t1
    }];
    $[2] = handleOrWallet;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== connectedProfile || $[6] !== handleOrWallet) {
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      const params_0 = {
        limit: `${REQUEST_SIZE}`,
        author: handleOrWallet,
        include_replies: "true"
      };
      if (pageParam) {
        params_0.serial_no_less_than = `${pageParam}`;
      }
      if (connectedProfile?.handle) {
        params_0.context_profile = connectedProfile.handle;
      }
      return await commonApiFetch({
        endpoint: "/drops",
        params: params_0
      });
    };
    $[5] = connectedProfile;
    $[6] = handleOrWallet;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      initialPageParam: null,
      placeholderData: keepPreviousData,
      getNextPageParam: _temp
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  } = useInfiniteQuery(t4);
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const [drops, setDrops] = useState(t5);
  let t6;
  if ($[12] !== data?.pages) {
    t6 = () => setDrops(data?.pages.flat().map(_temp2) ?? []);
    $[12] = data?.pages;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== data) {
    t7 = [data];
    $[14] = data;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== drops.length || $[17] !== fetchNextPage || $[18] !== hasNextPage || $[19] !== isFetching || $[20] !== isFetchingNextPage || $[21] !== status) {
    t8 = () => {
      if (drops.length < REQUEST_SIZE) {
        return;
      }
      if (status === "pending" || isFetching || isFetchingNextPage || !hasNextPage) {
        return;
      }
      fetchNextPage();
    };
    $[16] = drops.length;
    $[17] = fetchNextPage;
    $[18] = hasNextPage;
    $[19] = isFetching;
    $[20] = isFetchingNextPage;
    $[21] = status;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const onBottomIntersection = t8;
  let t10;
  let t9;
  if ($[23] !== onBottomIntersection) {
    t9 = () => {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1
      };
      const observer = new IntersectionObserver(entries => {
        if (entries[0]?.isIntersecting) {
          onBottomIntersection();
        }
      }, options);
      observerRef.current = observer;
      return () => {
        if (observerRef.current) {
          observerRef.current.disconnect();
        }
      };
    };
    t10 = [onBottomIntersection];
    $[23] = onBottomIntersection;
    $[24] = t10;
    $[25] = t9;
  } else {
    t10 = $[24];
    t9 = $[25];
  }
  useEffect(t9, t10);
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      if (bottomRef.current && observerRef.current) {
        observerRef.current.observe(bottomRef.current);
      }
      return () => {
        if (bottomRef.current && observerRef.current) {
          observerRef.current.unobserve(bottomRef.current);
        }
      };
    };
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== drops) {
    t12 = [drops];
    $[27] = drops;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  useEffect(t11, t12);
  let t13;
  if ($[29] !== isApp || $[30] !== router) {
    t13 = drop_0 => {
      const waveInfo = drop_0.wave as any;
      const isDirectMessage = waveInfo?.chat?.scope?.group?.is_direct_message ?? false;
      router.push(getWaveRoute({
        waveId: drop_0.wave.id,
        serialNo: drop_0.serial_no,
        isDirectMessage,
        isApp
      }));
    };
    $[29] = isApp;
    $[30] = router;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const navigateToDropWave = t13;
  let t14;
  if ($[32] !== navigateToDropWave) {
    t14 = drop_1 => {
      navigateToDropWave(drop_1);
    };
    $[32] = navigateToDropWave;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const onQuoteClick = t14;
  let t15;
  if ($[34] !== navigateToDropWave) {
    t15 = drop_2 => {
      navigateToDropWave(drop_2);
    };
    $[34] = navigateToDropWave;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const onDropContentClick = t15;
  const scrollContainerRef = useRef(null);
  if (status === "pending") {
    let t16;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <SpinnerLoader text="Loading drops..." />;
      $[36] = t16;
    } else {
      t16 = $[36];
    }
    return t16;
  }
  if (!drops.length && !isFetching) {
    let t16;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <div className="tw-text-sm tw-italic tw-text-iron-500">No Drops to show</div>;
      $[37] = t16;
    } else {
      t16 = $[37];
    }
    return t16;
  }
  let t16;
  if ($[38] !== drops || $[39] !== onDropContentClick || $[40] !== onQuoteClick) {
    t16 = <DropsList scrollContainerRef={scrollContainerRef} drops={drops} showWaveInfo={true} onReply={_temp3} onReplyClick={_temp4} serialNo={null} targetDropRef={null} showReplyAndQuote={false} activeDrop={null} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} dropViewDropId={null} location={DropLocation.PROFILE} />;
    $[38] = drops;
    $[39] = onDropContentClick;
    $[40] = onQuoteClick;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div ref={bottomRef} style={{
      height: "1px"
    }} />;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== isFetchingNextPage) {
    t18 = isFetchingNextPage && <SpinnerLoader text="Loading more drops..." />;
    $[43] = isFetchingNextPage;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t16 || $[46] !== t18) {
    t19 = <div className="tw-overflow-hidden" ref={scrollContainerRef}>{t16}{t17}{t18}</div>;
    $[45] = t16;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  return t19;
}
function _temp4() {}
function _temp3() {}
function _temp2(drop) {
  return {
    ...drop,
    type: DropSize.FULL,
    stableKey: drop.id,
    stableHash: drop.id
  };
}
function _temp(lastPage) {
  return lastPage.at(-1)?.serial_no ?? null;
}